"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _faSpinner = _interopRequireDefault(require("@fortawesome/fontawesome-free-solid/faSpinner"));

var _fontawesome = _interopRequireDefault(require("@fortawesome/fontawesome"));

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

_fontawesome.default.library.add(_faSpinner.default);

var Loading = function Loading(_ref) {
  var container = _ref.container,
      className = _ref.className,
      style = _ref.style,
      showText = _ref.showText;
  var Container = container;
  return _react.default.createElement(Container, {
    className: "text-center ".concat(className),
    style: style
  }, _react.default.createElement("i", {
    className: "fa fa-spinner fa-pulse fa-1x fa-fw"
  }), showText && _react.default.createElement(_reactIntl.FormattedMessage, {
    id: "loading"
  }));
};

Loading.propTypes = {
  container: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  showText: _propTypes.default.bool
};
Loading.defaultProps = {
  container: 'p',
  className: '',
  style: {},
  showText: true
};
var _default = Loading;
exports.default = _default;